export default __webpack_public_path__ + "static/media/christmas-scroll-closed.b457e5ce.png";